import AppShell from '../app/AppShell';
import { Panel } from '../components/dashboard';

function ModulePlaceholderPage({
  navigationItems,
  activePath,
  onNavigate,
  title,
  description,
}) {
  return (
    <AppShell
      navigationItems={navigationItems}
      activePath={activePath}
      onNavigate={onNavigate}
    >
      <section className="mt-5 px-4 sm:mt-6 sm:px-6 lg:px-[26px]">
        <Panel title={title} description={description}>
          <div className="rounded-[20px] border border-dashed border-[#e6ddd4] bg-[#fdfaf7] px-6 py-12 text-center text-[var(--theme-text-muted)]">
            This module is next in line. The Supplier page is the first module being built out.
          </div>
        </Panel>
      </section>
    </AppShell>
  );
}

export default ModulePlaceholderPage;
